import React from 'react';
import PropTypes from "prop-types";
import qs from 'qs';
import {connect} from 'react-redux';
import cn from "classnames";

import styles from '../../lib/global.css';
import Page from '../../components/page/page';

import { me } from '../../api/user';

import {getCourse} from '../../api/course';
import {setCourse, teachInitialState} from '../../reducers/teach';
import PageContentMargin from "../../components/page-content-margin/page-content-margin";
import LessonList from "../../components/lesson-list/lesson-list";
import CourseBanner from "./course-banner";
import ActiveBanner from "./active-banner";
import {saveLessonRecord} from "../../api/lesson-record";
import {showLoading} from "../../components/loading/loading";
import {setCourseRecords, setMyProjects, setUser} from "../../reducers/teach";
import ModalManager from "../../components/modal/modal-manager";

/**
 * 课程详情页
 */
class CoursePage extends React.PureComponent {
    constructor(props) {
        super(props);
        this.handleJoinCourse = this.handleJoinCourse.bind(this);
        this.getCourse = this.getCourse.bind(this);
        this.query = qs.parse(this.props.location.search, {ignoreQueryPrefix: true});
        if (this.props.course.id != this.query.id) this.props.setCourse(teachInitialState.course); //进到新课程，重新初始化
        this.state = {height: null}
    }

    componentDidMount() {
        this.getCourse();
        this.getUser();
        const height = document.body.clientWidth / 3
        this.setState({height: height})
    }

    componentWillUnmount(){
        ModalManager.closeAll()
    }

    handleJoinCourse(courseRecord) {
        this.getCourse();
    }

    getCourse() {
        getCourse(this.query, {quiet: !!this.props.course.id}).then(res => {
            this.props.setCourse(res)
            document.title = res.name
            if (res.record && res.lessons && !res.lessons[0].record) { //解锁第一课
                saveLessonRecord({
                    course_record_id: res.record.id,
                    lesson_id: res.lessons[0].id
                }).then();
            }
        });
    }

    getUser() {
        me({}, { quiet: !!this.props.username }).then(res => {
            this.props.setUser(res)
        })
    }

    render() {
        if (this.props.course.id != this.query.id) {
            return null;
        }
        const {course,user,history} = this.props;
        const {height} = this.state;
        return (
            <Page title={course.name} isModal={true}>
                {course.type === 1 ? (
                    <ActiveBanner course={course} user={user} history={history} showLoading={showLoading} height={height} onJoinCourse={this.handleJoinCourse} />
                ) : (
                    <PageContentMargin>
                        <CourseBanner course={course} clazz_id={this.query.clazz_id} clazz_code={this.query.clazz_code} props={this.props} onJoinCourse={this.handleJoinCourse} />
                        <LessonList items={course.lessons} courseId={this.query.id} clazzId={course.clazz_course&&course.clazz_course.clazz_id} vip={course.clazz_course&&course.clazz_course.exp_lesson_count?course.clazz_course.exp_lesson_count:null} user={user} />
                    </PageContentMargin>
                )}
            </Page>
        );
    }

}

CoursePage.propTypes = {
    course: PropTypes.object,
    setCourse: PropTypes.func,
    location: PropTypes.object,
}

const mapStateToProps = state => ({
    course: state.teach.course,
    user: state.teach.user
});


const mapDispatchToProps = dispatch => ({
    setCourse: course => dispatch(setCourse(course)),
    setUser: user => dispatch(setUser(user)),
    setCourseRecords: courseRecords => dispatch(setCourseRecords(courseRecords)),
    setMyProjects: projects => dispatch(setMyProjects(projects)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CoursePage);
